import { render, staticRenderFns } from "./ConfiguracionInformacion.vue?vue&type=template&id=3c203c60&scoped=true&"
import script from "./ConfiguracionInformacion.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c203c60",
  null
  
)

export default component.exports